module.exports = __webpack_public_path__ + "static/media/uvtv.8b25f112.png";